import types from '../mutation-types'

const state = {
  notifications: []
}

const actions = {
  flash({ commit, state }, payload) {
    commit(types.FLASH, {
      message: payload.message,
      type: payload.type
      // typeObject: this.classes(this.types, payload.type),
      // iconObject: this.classes(this.icons, payload.type)
    })
    // setTimeout(this.hide, this.timeout)
  },
  unflash({ commit, state }, payload) {
    commit(types.UNFLASH, payload)
  }
}

const getters = {
  notifications: state => {
    return state.notifications
  }
}

const mutations = {
  [types.FLASH](state, payload) {
    state.notifications.push(payload)
  },
  [types.UNFLASH](state, payload) {
    state.notifications.splice(payload, 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/flash.js